module.exports = __webpack_public_path__ + "static/media/Service-black.b17b0e08.svg";